import { Box, CircularProgress, useTheme } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../theme";
import { useTranslation } from 'react-i18next';

const DataTable = ({ title, columns, rows, getRowId }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  return (
    <Box m="20px">
      <h2>{title}</h2>
      <Box m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: colors.greenAccent[300] },
          "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[700], borderBottom: "none" },
          "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
          "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[700] },
          "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
            direction: isRTL ? "rtl" : "ltr",
            flexDirection: isRTL ? "row-reverse" : "row",
            justifyContent: isRTL ? "flex-start" : "flex-end",
            padding: "8px",
          },
        }}
      >
        <DataGrid 
          rows={rows} 
          columns={columns} 
          getRowId={getRowId} 
          checkboxSelection 
          components={{ Toolbar: GridToolbar }}
        />
      </Box>
    </Box>
  );
};

export default DataTable;
